export const FirebaseConfig = {
	"projectId": "ambi-1534f",
	"appId": "1:631538463861:web:2e837cd2650e498d4d343c",
	"databaseURL": "https://ambi-1534f-default-rtdb.firebaseio.com",
	"storageBucket": "ambi-1534f.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBKVKRg_Dc5ekltdbmAib5F9C0FhW-IlP4",
	"authDomain": "ambi-1534f.firebaseapp.com",
	"messagingSenderId": "631538463861",
	"measurementId": "G-HM4TJ959F0"
};